import React from 'react';
import _ from 'lodash';

import { Chip } from '@mui/material';
import { ApprovalTypeName } from 'generated/graphql';



export interface IProps {
  approvalTypeName: ApprovalTypeName;
}

export const FC: React.FC<IProps> = props => {
  return (
    <Chip
      size="small"
      color={__approvalType2Color[props.approvalTypeName]}
      label={_.upperFirst(props.approvalTypeName)} />
  );
};



const __approvalType2Color: Record<ApprovalTypeName, 'success' | 'error' | 'default'> = {
  approved: 'success',
  denied: 'error',
  pending: 'default'
};
